import { ResourceCardProps } from '../../../components/ResourceCard/ResourceCard';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
import { LinkDefination } from '../../../components';
import { transformContentCardCommonData } from '../article-card-transformer/article-card-transformer';

const transformResourceCard = (data: CMSTransformerDataType): ResourceCardProps => {
  const transformedContentCommonDetail = transformContentCardCommonData(data);
  let transformedContentDetail = {};
  if (data) {
    const viewLink: LinkDefination = {
      text: data?.link?.text,
      url: data?.link?.url,
      target: data?.link?.target,
    };
    transformedContentDetail = {
      subTitle: data?.sub_title,
      resourceType: data?.file_type,
      detailPage: data?.detail_page,
      link: viewLink,
    };
  }

  return {
    componentType: ComponentType.resource_card,
    ...transformedContentCommonDetail,
    ...transformedContentDetail,
  };
};

export default transformResourceCard;
